/*********************************************************************************************************************
 * @file Board reducers
 * @author Thomas Gantt <tg14@licorice.io>
 * @since 2.6.0
 * @date 4-Apr-2025
 *********************************************************************************************************************/
import { uri, GET } from '../../../constants.js';
import {
    setBoards
} from '../../../redux/actions/index.js';
import { ezRedux, genericRequest } from '../../../redux/reducerUtil.js';
import { abstractedCreateAuthRequest } from '../../../services/util/baseRequests.js';
import { __ } from '../../../utils/i18n.jsx';

/**
 * @typedef {object} BoardState
 * @property {array} boards
 */

/**
  * @type {BoardState}
  */
const initialState = Object.freeze({
    boards:                          [],
    fieldError:                     '',
});

const getBoardState = state => state.board;

// requests

const getBoards = () => genericRequest({}, abstractedCreateAuthRequest( GET, uri.GET_PROVIDERNAMES ), setBoards, [ ], 
    { 
        typeName:           'board',
        fields:             [ 'providerName.providerNameId', 'providerName.typeName', 'providerName.name', 'providerName.providerSourceId' ]
    }
);

const reducers = {
    [ setBoards ]:               ( draft, payload ) => draft.boards = payload,
};

export {
    getBoardState,
    getBoards
};

export default ezRedux( reducers, initialState );
